"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProximityRelationDef = isProximityRelationDef;
exports.isProximityRelationshipAttr = isProximityRelationshipAttr;
const relationship_guard_1 = require("./relationship.guard");
function isProximityRelationDef(relationDef) {
    return relationDef?.relationType === 'proximity';
}
function isProximityRelationshipAttr(attr) {
    return (0, relationship_guard_1.isRelationshipAttr)(attr) && isProximityRelationDef(attr.value.relation);
}
//# sourceMappingURL=relationship.proximity.guard.js.map